export default {
      id: "common__checkbox_all-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__checkbox_all",
      toString: function () {
        return this.url;
      }
    }